export default __webpack_public_path__ + "static/media/tick.1068b8e5.svg";